import _ from 'lodash'

export type NamedObject = {
  id?: string
  name?: string | null
}

/**
 * Checks if the given name is valid for the given list of objects.
 */
export function checkValidName(
  objects: NamedObject[],
  name?: string | null,
  id?: string,
  errorMessage?: string,
): void {
  if (_.isNil(name)) {
    return
  }

  // Check if there is another object with the same name that isn't the same object
  const duplicateObjectName = objects.find((object) => {
    const sameName = object.name?.trim().toLowerCase() === name.trim().toLowerCase()
    const sameObject = id !== undefined ? id === object.id : false
    return sameName && !sameObject
  })

  if (duplicateObjectName) {
    throw new Error(errorMessage ? errorMessage : `An object with the name ${name} already exists`)
  }
}

/**
 * Given a name, generates the name for the copy of that object
 */
export function getDuplicateName(name: string): string {
  // Extract and increment the copy number if the tab name ends with with " Copy" or " Copy - (number)"
  const copyRegex = / Copy(?:(\s-\s)\((\d+)\))?$/
  const match = name.match(copyRegex)
  let newName: string
  if (match) {
    const copyNumber = match[1] ? parseInt(match[2]) + 1 : 1
    newName = `${name.replace(copyRegex, '')} Copy - (${copyNumber})`
  } else {
    newName = `${name} Copy`
  }
  return newName
}
